export enum LoyaltyCategoryType {
  None = 0,
  Facebook = 101,
  Twitter = 102,
  GooglePlus = 103,
  FourSquare = 104,
  Instagram = 105,
  Youtube = 106,
  Membership = 200,
  Payment = 201,
  Events = 202,
  Notification = 203,
  Ticketing = 204,
  Marketplace = 205,
  Lotto = 206,
  Voucher = 207,
  Auction = 208,
  Surveys = 209,
  Fantasy = 210,
  Announcements = 211,
  PortalProducts = 212,
  Guardians = 213,
  GiftCodes = 214,
  UINotifications = 215,
  Worksheet = 216,
  CompanyOffer = 217,
  Scorecard = 218,
  Benefits = 219,
  Games = 220,
  Transactions = 280,
  MLBAMapp = 300,
}
